import { FaUsersCog as UsersEditIcon } from 'react-icons/fa';

export default UsersEditIcon;
